import { Box, Card, Group, Stack, Text } from '@mantine/core';
import IntegrationLogo from '@/pages/Integrations/components/IntegrationLogo.tsx';
import { ReactNode } from 'react';
import { HiOutlineInformationCircle } from 'react-icons/hi';
import StyledButton from '@/components/StyledButton/StyledButton.tsx';
import { IntegrationProvider } from '@/types/integrations.ts';

type props = {
  provider?: IntegrationProvider;
  action: ReactNode;
  setSelectedIntegration?: (provider?: IntegrationProvider) => void;
  showInfoIcon: boolean;
  children?: ReactNode;
};

const IntegrationProviderCard = ({
  provider,
  action,
  setSelectedIntegration,
  showInfoIcon,
  children,
}: props) => {
  if (!provider) {
    return null;
  }

  return (
    <Card
      padding={0}
      py={'md'}
      radius="md"
      withBorder
      w={'360px'}
      mih={'120px'}
      bg={'transparent'}
      mb={'auto'}
    >
      <Stack px="md" gap={0}>
        <Group justify={'space-between'} w={'100%'}>
          <Group gap={'5px'}>
            <Group gap={'xs'}>
              <IntegrationLogo name={provider.name} />
              <Text size={'14px'} fw={'medium'}>
                {provider.display_name}
              </Text>
            </Group>
            {showInfoIcon && (
              <StyledButton
                size={'sm'}
                variant={'subtleIcon'}
                aria-label={`View ${provider.display_name} details`}
                onClick={() => setSelectedIntegration?.(provider)}
                style={{
                  width: '24px',
                  height: '24px',
                  padding: 0,
                  borderRadius: '4px',
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'center',
                }}
              >
                <HiOutlineInformationCircle size={14} color={'#BABABA'} />
              </StyledButton>
            )}
          </Group>

          {action}
        </Group>

        <Text
          mt="lg"
          size={'sm'}
          c={'#757575'}
          style={{ textOverflow: 'ellipsis', overflow: 'hidden' }}
        >
          {provider.description}
        </Text>
      </Stack>

      <Box>{children}</Box>
    </Card>
  );
};

export default IntegrationProviderCard;
